// Fancybox
$( '[data-fancybox]' ).fancybox({
  infobar: true,
  afterShow: function(instance, current) {
    var imgSrc = current.src;

    var triggerLink = $('a[href="' + imgSrc + '"]');

    var altText = triggerLink.find('img').attr('alt');

    var customTitle = '<div class="fancybox-title">';
    customTitle += '<div class="fancybox-title-alt">' + altText + '</div>';
    customTitle += '</div>';

    if (altText) {
      current.$slide.find('.fancybox-content').append(customTitle).delay(5000);
    }
  },
  beforeClose: function(instance, current) {

    var titleElement = current.$slide.find('.fancybox-title');
    titleElement.css('visibility', 'hidden');
  }
  // caption : function( instance, item ) {
  //     var caption = $(this).data('caption') || '';
  //     return ( caption.length ? caption + '<br />' : '' ) + 'Image <span data-fancybox-index></span> of <span data-fancybox-count></span>';
  // }
});


